import { Box, LightMode, Stack, Text } from "@chakra-ui/react";
import { memo, useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { ApiErrorProvider } from "../../../components/ReactHookForm/ApiError";
import Splash from "../../../components/Splash";
import { Button } from "../../../components/ui";
import { useChannelManagerMeetingsCreateContext } from "../../ChannelManagerMeetings/Create/Context";
import { ChannelManagerMeetingsHandler } from "../../ChannelManagerMeetings/Create/Handler";
import { ChannelManagerMeetingsForm } from "../../ChannelManagerMeetings/Form";

export const ChannelManagerMeetingsBlock = memo(
  function ChannelManagerMeetingsBlock() {
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSuccess = useCallback(() => {
      setIsSuccess(true);
    }, []);

    const handleResetForm = useCallback(() => {
      setIsSuccess(false);
    }, []);

    const intl = useIntl();

    const { isEditor } = useChannelManagerMeetingsCreateContext();

    return (
      <LightMode>
        <Box position="relative">
          {isSuccess ? (
            <Stack spacing="1rem" justifyContent="center" alignItems="center">
              <Splash image="confirm" />

              <Text>
                {intl.formatMessage({
                  defaultMessage: "Votre demande a bien été prise en compte",
                })}
              </Text>

              <Text>
                <FormattedMessage defaultMessage="Nous avons bien reçu votre message. Un conseiller vous recontactera dans les plus brefs délais." />
              </Text>

              <Button
                onClick={handleResetForm}
                variant="outline"
                colorScheme="brandPrimary"
                borderColor="brandPrimary.700">
                <Text variant="button" color="brandPrimary.700">
                  <FormattedMessage defaultMessage="Retourner au formulaire" />
                </Text>
              </Button>
            </Stack>
          ) : (
            <ApiErrorProvider>
              <ChannelManagerMeetingsHandler onSuccess={handleSuccess}>
                {({ form, isLoading }) => (
                  <ChannelManagerMeetingsForm
                    control={form.control}
                    isLoading={isLoading}
                  />
                )}
              </ChannelManagerMeetingsHandler>
            </ApiErrorProvider>
          )}
          {isEditor && (
            <Box position="absolute" top="0" left="0" w="full" h="full" />
          )}
        </Box>
      </LightMode>
    );
  },
);
